module.exports = __webpack_public_path__ + "img/button-dislike.1437d146.svg";